import React from 'react';
import styles from './Footer.module.css';

export const Footer: React.FC = () => {
  return (
    <footer className={styles.magazineFooter}>
      <p>NICKLAS NORDSTRÖM © 2025 • JOURNALIST • MALMÖ, SWEDEN</p>
    </footer>
  );
};
